import PropTypes, { number } from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { useRouter } from 'next/router'
import useTranslation from 'next-translate/useTranslation'
import ReactSVG from 'react-svg'
import { getVehiclePart } from 'SRC/modules/vehicleParts/detail/selectors'
import { BreadCrumbsItem } from '../BreadCrumbsItem'

import translations from '../../../../../../public/data/translations.json'

const BCIcon = () => {
	return (
		<ReactSVG src='/icons/home.svg' beforeInjection={svg => {
			svg.setAttribute('style', 'width: 20px; height: 20px; margin-right: 7px;');
			svg.querySelectorAll('path').forEach(path => {
				path.setAttribute('fill', '#000');
			});
		}} wrapper='span' />
	)
}

const getBreadcrumbItems = (product, t, lang) => {
	if (!product || !product.group || !product.category) return []

	let baseAs = `/${translations.noviDjeloviUrl[lang?.toUpperCase() || 'ME']}`

	const breadCrumbItems = [
		{ key: 'home', as: '/', href: { pathname: '/' }, text: t('Početna'), isLast: false },
	]

	const groupItem = {
		key: 'group',
		as: `${baseAs}/${translations['auto-djelovi'][lang?.toUpperCase() || 'ME'].gume.slug}`,
		href: { pathname: '/vehicleParts', query: { group: translations['auto-djelovi'][lang?.toUpperCase() || 'ME'].gume.slug } },
		text: translations['auto-djelovi'][lang?.toUpperCase() || 'ME'].gume.title,
		isLast: false
	}

	const sirinaItem = {
		key: 'sirina',
		as: `${groupItem.as}/${translations.pretraga[lang?.toUpperCase() || 'ME']}?width=${product?.tire_width_slug?.slug}`,
		href: { pathname: '/vehiclePartsSearch', query: { ...groupItem.href.query, width: product?.tire_width_slug?.slug } },
		text: product?.tire_width_slug?.name,
		isLast: false
	}

	const visinaItem = {
		key: 'visina',
		as: `${sirinaItem.as}&height=${product?.tire_height_slug?.slug}`,
		href: { pathname: '/vehiclePartsSearch', query: { ...sirinaItem.href.query, height: product?.tire_height_slug?.slug } },
		text: product?.tire_height_slug?.name,
		isLast: false
	}

	const promjerItem = {
		key: 'promjer',
		as: `${visinaItem.as}&diameter=${product?.tire_diameter_slug?.slug}`,
		href: { pathname: '/vehiclePartsSearch', query: { ...visinaItem.href.query, diameter: product?.tire_diameter_slug?.slug } },
		text: product?.tire_diameter_slug?.name,
		isLast: false
	}

	const sezonaItem = {
		key: 'sezona',
		as: `${promjerItem.as}&season=${product?.tire_season_slug?.slug}`,
		href: { pathname: '/vehiclePartsSearch', query: { ...promjerItem.href.query, season: product?.tire_season_slug?.slug } },
		text: product?.tire_season_slug?.name,
		isLast: false
	}

	const productItem = {
		key: 'product',
		as: `${sezonaItem.as}&product=${product?.name?.slug}`,
		href: { pathname: '/vehiclePartsSearch', query: { ...sezonaItem.href.query, product: product?.name?.slug } },
		text: product?.name?.name,
		isLast: true
	}

	breadCrumbItems.push(groupItem, sirinaItem, visinaItem, promjerItem, sezonaItem, productItem)

	return breadCrumbItems
}

const BreadCrumbs = ({ product }) => {
	const { t, lang } = useTranslation('common')

	let breadCrumbItems = getBreadcrumbItems(product, t, lang)
	console.log('BreadCrumbs breadCrumbItems', breadCrumbItems)
	
	if (!breadCrumbItems.length) return null

	return (
		<div className='vehicle-part-breadcrumbs'>
			<BCIcon />
			{breadCrumbItems.map((breadCrumbItem, i) => (
				<BreadCrumbsItem
					key={breadCrumbItem.key}
					as={breadCrumbItem.as}
					href={breadCrumbItem.href}
					text={breadCrumbItem.text}
					isLast={breadCrumbItem.isLast}
				/>
			))}
		</div>
	)
}

BreadCrumbs.propTypes = {
	product: PropTypes.shape({
		group: PropTypes.shape({
			name: PropTypes.string,
			slug: PropTypes.string,
		}),
		category: PropTypes.shape({
			name: PropTypes.string,
			slug: PropTypes.string,
		}),
		car_brand: PropTypes.shape({
			name: PropTypes.string,
			slug: PropTypes.string,
		}),
		car_model: PropTypes.shape({
			name: PropTypes.string,
			slug: PropTypes.string,
		}),
		year: PropTypes.shape({
			name: PropTypes.string,
			slug: PropTypes.string,
		}),
		engine: PropTypes.shape({
			name: PropTypes.string,
			slug: PropTypes.string,
		}),
	}).isRequired,
}

const mapStateToProps = state => {
	return {
		product: getVehiclePart(state),
	}
}

export default connect(mapStateToProps)(BreadCrumbs)
